import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../../../apiConfigs/axiosInstance";

import { renderDynamicUrlFromState } from "../../../../helpers/utils/urlHelper";

export const getLps = createAsyncThunk(
  "getLps",
  async (page: string, { dispatch, rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.get(`${dynamic_url}/get-lps`);
      return res.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllUserCourses = createAsyncThunk(
  "getAllUserCourses",
  async (page: string, { dispatch, rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state); // ;
      const res = await axiosInstance.get(`${dynamic_url}/all-user-courses`);
      return res.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
